import React from "react";
import { EditButton, useDisclosure } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../../../../../core/security/SprintAccessRight";
import { EditEmbeddedSubtitleAside } from "./EditEmbeddedSubtilteAside";

export interface EditEmbeddedSubtitleButtonAsideProps {
    fileRecordId: string;
    isDisabled: boolean;
    isLabeled?: boolean;
}

export const EditEmbeddedSubtitleButtonAside: React.FunctionComponent<EditEmbeddedSubtitleButtonAsideProps> = (
    props: EditEmbeddedSubtitleButtonAsideProps
) => {
    const { fileRecordId, isLabeled, isDisabled } = props;

    const { isOpen, onOpen, onClose } = useDisclosure();

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.CiReadWrite]}>
            <EditButton
                onClick={onOpen}
                isLabeled={isLabeled}
                label="Edit"
                testId="edit-embedded-subtitle"
                disabled={isDisabled}
            />
            <EditEmbeddedSubtitleAside
                fileRecordId={fileRecordId}
                isOpen={isOpen}
                onCancel={onClose}
                onSubmit={onClose}
            />
        </AuthorizationWrapper>
    );
};
